import { TFavoriteOfferRef } from './types';
import { EOfferType } from '../../repositories/dailyrent/entities/daily_rent_offers_for_web/DailyRentOfferForMobileSite';
import {
  EDealType,
  EEntityType,
} from '../../repositories/favorites/entities/add_favorite/AddFavoriteEntityPublicRequestSchema';
import { IDeleteOfferFromFavoritesResponse } from '../../repositories/favorites/v1/delete-offer-from-favorites';
import { fetchRemoveFromFavorites } from '../../services/newFavorites/fetchRemoveFromFavorites';
import { ITypedReduxAction, TThunkAction } from '../../types/redux';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum ERemoveFromFavoritesActionTypes {
  Request = 'removeFromFavorites/request',
  Success = 'removeFromFavorites/success',
  Failure = 'removeFromFavorites/failure',
}

interface IChangeFavoritePayload {
  offerId: number;
  isFavorite: boolean;
}

export type TRequestRemoveFromFavorites = ITypedReduxAction<ERemoveFromFavoritesActionTypes.Request>;
export type TSuccessRemoveFromFavorites = ITypedReduxAction<
  ERemoveFromFavoritesActionTypes.Success,
  IChangeFavoritePayload
>;
export type TFailureRemoveFromFavorites = ITypedReduxAction<ERemoveFromFavoritesActionTypes.Failure>;

export const requestRemoveFromFavorites: () => TRequestRemoveFromFavorites =
  actionGenerator<ERemoveFromFavoritesActionTypes.Request>(ERemoveFromFavoritesActionTypes.Request);

export const successRemoveFromFavorites: (payload: IChangeFavoritePayload) => TSuccessRemoveFromFavorites =
  actionGenerator<ERemoveFromFavoritesActionTypes.Success, IChangeFavoritePayload>(
    ERemoveFromFavoritesActionTypes.Success,
  );

export const failureRemoveFromFavorites: () => TFailureRemoveFromFavorites =
  actionGenerator<ERemoveFromFavoritesActionTypes.Failure>(ERemoveFromFavoritesActionTypes.Failure);

export const removeFromFavorites =
  (offer: TFavoriteOfferRef): TThunkAction<Promise<IDeleteOfferFromFavoritesResponse>> =>
  async (dispatch, _getState, context) => {
    const { logger } = context;

    if (!offer?.cianId) {
      logger.error('Не удалось удалить объявление из избранного', {
        domain: 'dailyrent-search-frontend/removeFromFavorites',
      });
      throw new Error('Объявление не найдено');
    }

    const entityType = offer.offerType === EOfferType.Flat ? EEntityType.OfferResidental : EEntityType.OfferSuburban;

    try {
      dispatch(requestRemoveFromFavorites());

      const result = await fetchRemoveFromFavorites(context, {
        entityId: offer.cianId,
        dealType: EDealType.Rent,
        entityType,
      });

      dispatch(
        successRemoveFromFavorites({
          offerId: offer.id,
          isFavorite: false,
        }),
      );

      return result;
    } catch (error) {
      dispatch(failureRemoveFromFavorites());

      logger.error(error);
      throw error;
    }
  };
